module.exports = __webpack_public_path__ + "img/beta.593a0855.svg";